module["exports"] = [
  "Pan",
  "Pani"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pl/name/prefix.js
// module id = 1001
// module chunks = 0